import React from 'react';

import styled from 'styled-components';

import { socialTypes } from '@constants/Socials';

import { friendlyNumber } from '@libs/NwUtils';

import SocialIcon from '@components/Social/SocialIcon';
import { buildUrl, ensureHttps } from '@components/Social/SocialUtil';

const ContactSocialLinkContainer = styled.div`
    display: flex;
    align-items: center;
    padding-right: 2rem;

    .url-and-followers {
        a {
            display: block;
            word-break: break-all;
        }
        small {
            display: block;
            text-transform: uppercase;
        }
    }
`;

const ContactSocialLink = ({ contactSocial, contactType, showUrl }) => {
    let socialType = socialTypes.find((socialtype) => socialtype.code === contactSocial.Type);
    if (!socialType) {
        socialType = socialTypes.find((socialtype) => socialtype.code === 'Other');
    }
    const socialUrl = buildUrl(socialType, contactSocial.Url, contactType);
    const fixedSocialUrl = ensureHttps(socialUrl);

    return (
        <ContactSocialLinkContainer className="contact-social-link">
            <SocialIcon
                className="contact-social-icon"
                size="big"
                onClick={() => {
                    window.open(fixedSocialUrl, '_blank');
                }}
                social={socialType}
                socialUrl={!showUrl ? socialUrl : null}
                socialFollowers={contactSocial.Followers}
            />
            {showUrl && (
                <div className="url-and-followers">
                    <a target="_blank" className="nw-link" href={fixedSocialUrl} rel="noopener noreferrer">
                        {socialUrl}
                    </a>
                    {contactSocial.Followers && contactSocial.Followers > 0 ? (
                        <small>
                            Followers: {friendlyNumber(contactSocial.Followers)} [{contactSocial.Followers}]
                        </small>
                    ) : (
                        <></>
                    )}
                </div>
            )}
        </ContactSocialLinkContainer>
    );
};

export default ContactSocialLink;
